'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_model$package$CuisineId$() {
  $n_Lmealorama_model$package$CuisineId$ = this;
  $m_Lmealorama_model$package$CuisineId$();
}
export { $c_Lmealorama_model$package$CuisineId$ as $c_Lmealorama_model$package$CuisineId$ };
$p = $c_Lmealorama_model$package$CuisineId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_model$package$CuisineId$;
/** @constructor */
function $h_Lmealorama_model$package$CuisineId$() {
}
export { $h_Lmealorama_model$package$CuisineId$ as $h_Lmealorama_model$package$CuisineId$ };
$h_Lmealorama_model$package$CuisineId$.prototype = $p;
var $d_Lmealorama_model$package$CuisineId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_model$package$CuisineId$, "mealorama.model$package$CuisineId$", ({
  KO: 1
}));
export { $d_Lmealorama_model$package$CuisineId$ as $d_Lmealorama_model$package$CuisineId$ };
var $n_Lmealorama_model$package$CuisineId$;
function $m_Lmealorama_model$package$CuisineId$() {
  if ((!$n_Lmealorama_model$package$CuisineId$)) {
    $n_Lmealorama_model$package$CuisineId$ = new $c_Lmealorama_model$package$CuisineId$();
  }
  return $n_Lmealorama_model$package$CuisineId$;
}
export { $m_Lmealorama_model$package$CuisineId$ as $m_Lmealorama_model$package$CuisineId$ };
//# sourceMappingURL=mealorama.model$package$-Cuisine-Id$.js.map
